import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Plan } from '../../shared/classes/plan';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { PlanService } from '../../shared/services/plan.service';
import { UserService } from '../../shared/services/user.service';
import { forkJoin } from 'rxjs';
import { Utilities } from '../../shared/utilities';
import {Settings} from '../../shared/settings';

@Component({
  templateUrl: './subscription-result.component.html',
  styleUrls: ['./subscription-result.component.css']
})

export class SubscriptionResultComponent implements OnInit, OnDestroy {

  public loading = true;
  public plans: Plan[] = [];
  public plan: Plan = null;
  public error = '';
  public message = '';
  public planId = null;
  public estado = '';
  public paramMessage = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private planService: PlanService,
    private userService: UserService
  ) {
    const that = this;
    that.route.queryParams.subscribe(params => {
      that.planId = params.planId ? params.planId : null;
      that.estado = params.estado ? params.estado.toUpperCase() : null;
      that.paramMessage = params.mensaje ? params.mensaje : null;
      that.loadData();
    });
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  public userIsLoggedIn(): boolean {
    return this.authenticationService.userIsLoggedIn();
  }

  loadData(successMessage?: string): void {
    const that = this;
    that.loading = true;
    if (that.estado === 'APROBADO') {
      let errorFound = false;
      that.plans = [];
      forkJoin([
        that.planService.getActivePlans(),
        that.userService.getUserSubscriptions(this.userIsLoggedIn())
      ]).subscribe(([getActivePlansResponse, getUserSubscriptionsResponse]) => {
          if (getActivePlansResponse) {
            if (!getActivePlansResponse.HasError && getActivePlansResponse.Planes) {
              getActivePlansResponse.Planes.forEach(onePlan => that.plans.push(Plan.parse(onePlan)));
            } else {
              errorFound = true;
              if (getActivePlansResponse.ErrorMessage){
                that.error = `<p><b>¡Error!</b></p><p>${getActivePlansResponse.ErrorMessage}</p>`;
              } else {
                that.error = '<p>Ha ocurrido un error, por favor, intente nuevamente.</p>';
              }
            }
          } else {
            errorFound = true;
            that.error = '<p>Ha ocurrido un error, por favor, intente nuevamente.</p>';
          }
          if (getUserSubscriptionsResponse) {
            if (!getUserSubscriptionsResponse.HasError && getUserSubscriptionsResponse.Suscripciones) {
              // Por cada Id de plan que tiene el usuario, busco el plan y le seteo la property LoggedInUserHasPlan en true
              getUserSubscriptionsResponse.Suscripciones.forEach(
                oneUserSubscription => {
                  const plan = that.plans.find(
                    onePlan => onePlan.PlanId === oneUserSubscription.SuscripcionPlanId && oneUserSubscription.SuscripcionEstado === 'ACTIVA'
                  );
                  if (plan) {
                    plan.LoggedInUserHasPlan = true;
                  }
                }
              );
            } else {
              errorFound = true;
              if (getUserSubscriptionsResponse.ErrorMessage){
                that.error = `<p><b>¡Error!</b></p><p>${getUserSubscriptionsResponse.ErrorMessage}</p>`;
              } else {
                that.error = '<p>Ha ocurrido un error, por favor, intente nuevamente.</p>';
              }
            }
          } else {
            errorFound = true;
            that.error = '<p>Ha ocurrido un error, por favor, intente nuevamente.</p>';
          }

          if (!errorFound) {
            that.plan = that.plans.find(onePlan => onePlan.PlanId === that.planId);

            if (!that.plan) {
              that.error = '<p>No se ha encontrado información sobre el plan que desea contratar.</p>';
            } else if (that.plan.LoggedInUserHasPlan) {

              const script = `
              <!-- Event snippet for Suscripción Exitosa conversion page -->
              <script>
                gtag('event', 'conversion', {'send_to': 'AW-675916236/E03_CKSEh4IDEMzTpsIC'});
              </script>
            `;
              document.getElementsByTagName('head')[0].innerHTML += script;

              that.message = `<p>Usted se encuentra suscrito correctamente al plan "${that.plan.PlanName}".</p>`;
              // Esperar 15 segundos y redireccionar a teng
              if (Settings.redirectURLAfterSuccessfulSubscription && Settings.redirectionAfterSuccessfulSubscriptionTimeout) {
                setTimeout(() => {
                  window.location.href = Settings.redirectURLAfterSuccessfulSubscription;
                }, 5000);
              }
            } else {
              that.error = `<p><b>Usted no se encuentra suscrito al plan "${that.plan.PlanName}".</b></p><br><p>Si desea suscribirse, dirígase a la pantalla de planes.</p>`;
            }
            if (successMessage) {
              that.message = successMessage;
            }
          }

          that.loading = false;
        },
        (error) => {
          Utilities.logError('Error al cargar los planes activos');
          Utilities.logError(error);
          that.loading = false;
          that.error = '<p><b>Ha ocurrido un error.</b></p><p>Por favor, intente nuevamente.</p>';
        });
    } else if (that.estado === 'ERROR') {
      that.error = `<p>${that.paramMessage}</p>`;
      that.loading = false;
    } else {
      that.error = '<p><b>Error.</b></p><p>No se ha podido verificar el resultado de la operación.</p>';
      that.loading = false;
    }
  }

  public goTo(url): void {
    this.router.navigate([url]);
  }
}
